module.exports = __webpack_public_path__ + "img/2.a9d4dfb6.png";